import React from "react";
import Swiper from "react-id-swiper";
import "swiper/css/swiper.css";
import pic from "../assets/images/medical_article/medical.jpg";

const BlogTwo = () => {
  const params = {
    slidesPerView: 3,
    loop: true,
    speed: 1000,
    spaceBetween: 30,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },

    // Responsive breakpoints
    breakpoints: {
      1024: {
        slidesPerView: 3
      },
      768: {
        slidesPerView: 2
      },
      640: {
        slidesPerView: 1
      },
      320: {
        slidesPerView: 1
      }
    }
  };

  return (
    <section className="blog-two">
      <div className="container">
        <div className="block-title text-center">
          <h2 className="block-title__title">
            最新文章<br />& 通知
          </h2>
        </div>
        <div className="blog-two__carousel">
          <Swiper {...params}>
            <div className="item">
              <div
                className="blog-two__single"
                style={{ backgroundImage: `url(${pic})` }}
              >
                <div className="blog-two__inner">
                  <a href="#none" className="blog-two__date">
                    <span>25</span>
                    8月
                  </a>
                  <div className="blog-two__meta">
                    <a href="/article-details"> 苏州大学附属第一医院药学部</a>
                  </div>
                  <h3 className="blog-two__title">
                    <a href="/article-details">
                     多环节质量控制在降低静配中心退药率的应用实践<br/>
                    </a>
                  </h3>
                </div>
              </div>
            </div>
            <div className="item">
              <div
                className="blog-two__single"
                style={{ backgroundImage: `url(${pic})` }}
              >
                <div className="blog-two__inner">
                  <a href="#none" className="blog-two__date">
                    <span>18</span>
                    9月
                  </a>
                  <div className="blog-two__meta">
                    <a href="/article-details"> 上海普陀中心医院药学部</a>
                  </div>
                  <h3 className="blog-two__title">
                    <a href="/article-details">
                    医院静脉用药调配中心的自动化系统建设与实践
                    </a>
                  </h3>
                </div>
              </div>
            </div>
            <div className="item">
              <div
                className="blog-two__single"
                style={{ backgroundImage: `url(${pic})` }}
              >
                <div className="blog-two__inner">
                  <a href="#none" className="blog-two__date">
                    <span>25</span>
                    10月
                  </a>
                  <div className="blog-two__meta">
                    <a href="/article-details">南京医科大学附属儿童医院药学部</a>

                  </div>
                  <h3 className="blog-two__title">
                    <a href="/article-details">
                    智能标签打印系统在医院静脉用药集中调配中心的应用
                    </a>
                  </h3>
                </div>
              </div>
            </div>
            <div className="item">
              <div
                className="blog-two__single"
                style={{ backgroundImage: `url(${pic})` }}
              >
                <div className="blog-two__inner">
                  <a href="#none" className="blog-two__date">
                    <span>06</span>
                    12月
                  </a>
                  <div className="blog-two__meta">
                    <a href="/article-details"> 匿名</a>
                   
                  </div>
                  <h3 className="blog-two__title">
                    <a href="/article-details">
                    静脉用药集中调配中心智能化、信息化、均质化建设的实践
                    </a>
                  </h3>
                </div>
              </div>
            </div>
            <div className="item">
              <div
                className="blog-two__single"
                style={{ backgroundImage: `url(${pic})` }}
              >
                <div className="blog-two__inner">
                  <a href="#none" className="blog-two__date">
                    <span>13</span>
                    1月
                  </a>
                  <div className="blog-two__meta">
                    <a href="/article-details"> 匿名</a>
                   
                  </div>
                  <h3 className="blog-two__title">
                    <a href="/article-details">
                    我院PIVAS的自动化建设与实践
                    </a>
                  </h3>
                </div>
              </div>
            </div>
            <div className="item">
              <div
                className="blog-two__single"
                style={{ backgroundImage: `url(${pic})` }}
              >
                <div className="blog-two__inner">
                  <a href="#none" className="blog-two__date">
                    <span>30</span>
                    2月
                  </a>
                  <div className="blog-two__meta">
                    <a href="/article-details"> 苏州科技城医院</a>
                  </div>
                  <h3 className="blog-two__title">
                    <a href="/article-details">
                    一体化智能 PIVAS/住院药房的构建和应用
                    </a>
                  </h3>
                </div>
              </div>
            </div>
            <div className="item">
              <div
                className="blog-two__single"
                style={{ backgroundImage: `url(${pic})` }}
              >
                <div className="blog-two__inner">
                  <a href="#none" className="blog-two__date">
                    <span>16</span>
                    3月
                  </a>
                  <div className="blog-two__meta">
                    <a href="/article-details"> 天津医科大学总医院</a>
                  </div>
                  <h3 className="blog-two__title">
                    <a href="/article-details">
                    自动化建设提升我院 PIVAS 药学服务质量
                    </a>
                  </h3>
                </div>
              </div>
            </div>
          </Swiper>
        </div>
      </div>
    </section>
  );
};
export default BlogTwo;
